// 客服管理
export default [
  {
    path: "/customerService",
    meta: { title: "客服管理" },
    component: () => import("../views/customerService/index"),
    children: [
      {
        path: "/customerService/qrcode",
        meta: { title: "客服二维码", isMenu: true },
        component: () => import("../views/customerService/qrcode.vue"),
      },
      {
        path: "/customerService/pushMessage",
        meta: { title: "消息群发", isMenu: true },
        component: () => import("../views/customerService/pushMessage.vue"),
      },
      {
        path: "/customerService/detail/add",
        meta: { title: "消息内容" },
        component: () => import("../views/customerService/detail/add.vue"),
      },
    ],
  },
]
